import { ChangeEvent, useMemo } from 'react';

import { getUuid } from '~utils/common';

import { Props as TinyDropDownProps } from '..';
import { getOptionText } from '../helper';
import * as S from './style';

interface Props extends Pick<TinyDropDownProps, 'options' | 'onChange' | 'value'> {}

export default function SelectMobile({ value, options, onChange }: Props) {
  const prefixKey = useMemo(() => getUuid(), []);
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { selectedIndex } = e.target;
    const newSelectedValue = options[selectedIndex].value;

    if (onChange) {
      onChange(newSelectedValue);
    }
  };

  return (
    <S.Select value={value} onChange={handleChange}>
      {options.map((option, index) => (
        <option key={`${prefixKey}-value-${index}`} value={option.value} disabled={option.disabled}>
          {getOptionText(option)}
        </option>
      ))}
    </S.Select>
  );
}
